import VideoPlayerContainer from "./VideoPlayer.styled";
import Stack from "../Utils/Stack.styled";
import Title from "../Utils/Title.styled";
import Video from "../Video";
import useNavigateParams from "../../helper/navigateHelper";
import { motion } from "framer-motion";
import { forwardRef } from "react";
import { CloseIcon } from "../Modal/Modal.styled";
import Icon from "../Icon/Icon";
import CONSTANT from "../../constants/constant";
import useQueueStore from "../../stores/queueStore";
import MessageModal from "../MessageModal";
import { useState } from "react";
import usePlayListStore from "../../stores/playlistStore";

const VideoPlayer = ({ videoId, selectedVideo, param, onClose }, ref) => {
  const navigate = useNavigateParams();
  const currentQueues = useQueueStore((state) => state.currentQueues);
  const clearQueue = useQueueStore((state) => state.clearQueue);
  const clearCurrentPlayingPlaylist = usePlayListStore(
    (state) => state.clearCurrentPlayingPlaylist
  );
  const [showMessageModal, setShowMessageModal] = useState(false);
  const onCloseVideo = () => {
    clearCurrentPlayingPlaylist();
    if (currentQueues.length > 0) {
      setShowMessageModal(true);
    } else {
      setShowMessageModal(false);
      onClose("");
    }
  };

  const getButtonStatus = (key) => {
    if (key === CONSTANT.LABEL.CONFIRM) {
      clearQueue();
      onClose("");
    }
    setShowMessageModal(false);
  };

  return (
    <VideoPlayerContainer
      as={motion.div}
      key={selectedVideo.videoId}
      drag
      dragConstraints={!videoId ? ref : ""}
      id={videoId}
    >
      {!videoId && (
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          height="fit-content"
        >
          <Title
            onClick={() => {
              navigate(`${selectedVideo.videoId}`, {
                q: param ? param : selectedVideo.title,
              });
            }}
            hover
          >
            {selectedVideo.title}
          </Title>
          <CloseIcon onClick={() => onCloseVideo()}>
            <Icon type={CONSTANT.ICON.CLOSE} size="20px"></Icon>
          </CloseIcon>
        </Stack>
      )}

      <Video
        id={selectedVideo.id}
        title={selectedVideo.title}
        videoId={selectedVideo.videoId}
        playing={selectedVideo.isPlayingNow}
      ></Video>
      {showMessageModal && (
        <MessageModal
          title={CONSTANT.ERROR.QUEUE_TITLE}
          message={CONSTANT.ERROR.QUEUE_MESSAGE}
          onClick={getButtonStatus}
          showConfirmButton
        />
      )}
    </VideoPlayerContainer>
  );
};

export default forwardRef(VideoPlayer);
